import { Skeleton } from "@/shared/components/ui/skeleton";
import { HTMLAttributes } from "react";
import { useHtzAirHandlingUnitDataShowQuery } from "@/services/backend/htz/ahu/api/ahu-data-api";

export function AhuDataLabelName({
  ahuDataId,
  className,
  ...props
}: { ahuDataId: string } & HTMLAttributes<HTMLSpanElement>) {
  const { data } = useHtzAirHandlingUnitDataShowQuery({ id: ahuDataId });
  return (
    <span className={className} {...props}>
      {data?.label || <Skeleton className="inline-flex h-4 w-24" />}
    </span>
  );
}
